import { ArrowLeft, ArrowRight } from "@material-ui/icons";
import React from "react";

type Props = {
  setStep: (step: number) => void;
};

const StepTwo = ({ setStep }: Props) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <p>Répeter l'opération de l'étape 1 pour le 2ème polygone.</p>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        <img src="/step2.gif" alt="help" width="250" height="250" />
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setStep(1)}
        >
          <ArrowLeft /> Étape 1
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setStep(3)}
        >
          Étape 3 <ArrowRight />
        </div>
      </div>
    </div>
  );
};

export default StepTwo;
